import { signalStore } from '@ngrx/signals';
import { withConfig } from './features/config.feature';

/**
 * Advanced Commerce Config Store
 *
 * @link https://ngrx.io/guide/signals/signal-store
 */
export const AdvancedCommerceConfigStore = signalStore({ providedIn: 'root' }, withConfig());
